import axios from 'axios'
export default  
{  


getToken : () =>

axios({
  url      : "https://mosaico.connectasrl.it/MOSAICO/mosaico_api_dev/token",               
  method   : 'post',
  data     : {"username":"client_api","password":"0^hgHHdw32ecsaD"},
  headers  : {'Mosaico-Account-Code' : 'BertiniMax'},

  
}).then(res => {
  
  console.log('BERTINI TOKEN RESPONSE ',res)

  return res
}).catch(err => {
  if(err.response)
  {
    console.log('BERTINI TOKEN ERROR',err.response)
    return err.response
  }
  console.log('BERTINI TOKEN ERROR',err.message)
  return err.message
})
.finally(() => {
  console.log('BERTINI ')

})

,

postProduct : (json,token) => 
axios({
  url      : "https://mosaico.connectasrl.it/MOSAICO/mosaico_api_dev/product",               
  method   : 'post',
  data     : json,
  headers  : {'Mosaico-Account-Code' : 'BertiniMax','Mosaico-Token':token},

  
}).then(res => {
  
  return res
}).catch(err => {
  if(err.response)
  {
    return err.response
  }
 
  return err.message
})
.finally(() => {})
,
postVariants : (json,token) => 

axios({
  url      : "https://mosaico.connectasrl.it/MOSAICO/mosaico_api_dev/product/variants",               
  method   : 'post',
  data     : json,
  headers  : {'Mosaico-Account-Code' : 'BertiniMax','Mosaico-Token':token},

  
  }).then(res => {
    console.log(json)
  return res
}).catch(err => {
  if(err.response)
  {
    return err.response
  }
 
  return err.message
})
.finally(() => {})
,

postStock : (json,token) => 
axios({
  url      : "https://mosaico.connectasrl.it/MOSAICO/mosaico_api_dev/product/variants/stock",               
  method   : 'post',
  data     : json,
  headers  : {'Mosaico-Account-Code' : 'BertiniMax','Mosaico-Token':token},

  
}).then(res => {
  console.log(res)
  return res
}).catch(err => {
  if(err.response)
  {
    return err.response
  }
 
  return err.message
})
.finally(() => {})
,
postSeo : (json,token) => 
axios({
  url      : "https://mosaico.connectasrl.it/MOSAICO/mosaico_api_dev/product/seo",               
  method   : 'post',
  data     : json,
  headers  : {'Mosaico-Account-Code' : 'BertiniMax','Mosaico-Token':token},

  
}).then(res => {
  
  return res
}).catch(err => {
  if(err.response)
  {
    return err.response
  }
 
  return err.message
})
.finally(() => {}),

getProduct : (product,token) => 
axios({
  url      : "https://mosaico.connectasrl.it/MOSAICO/mosaico_api_dev/product/info/" + product,               
  method   : 'get',
  headers  : {'Mosaico-Account-Code' : 'BertiniMax','Mosaico-Token':token},

  
}).then(res => {
  
  return res
}).catch(err => {
  if(err.response)
  {
    return err.response
  }
 
  return err.message
})
.finally(() => {}),


getStock : (items) =>
    {
      let data = {'variants':[]}
      items.forEach(item => {
        data.variants.push({'product_code':item.product_code,'variant_code':item.variant_code,'warehouse_id':'1','stock':item.stock.toString()})
      })

      return data
    }

}
